var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61499 16.5C4.20249 16.5 3.84924 16.353 3.55524 16.059C3.26124 15.765 3.11449 15.412 3.11499 15V4.5H4.61499V15H12.865V16.5H4.61499ZM7.61499 13.5C7.20249 13.5 6.84924 13.353 6.55524 13.059C6.26124 12.765 6.11449 12.412 6.11499 12V3C6.11499 2.5875 6.26199 2.23425 6.55599 1.94025C6.84999 1.64625 7.20299 1.4995 7.61499 1.5H14.365C14.7775 1.5 15.1307 1.647 15.4247 1.941C15.7187 2.235 15.8655 2.588 15.865 3V12C15.865 12.4125 15.718 12.7658 15.424 13.0598C15.13 13.3538 14.777 13.5005 14.365 13.5H7.61499ZM7.61499 12H14.365V3H7.61499V12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.232f8d6c6ed39157e8fbd402579d746d.svg";
export { ForwardRef as ReactComponent };